import React, { useState, useEffect } from "react";
import "./navbar.css";
import axios from "axios";
import API_ENDPOINT from "../wm.api.service";
import IconButton from "@material-ui/core/IconButton";
import NotificationsSharpIcon from "@material-ui/icons/NotificationsSharp";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import SearchBar from "../searchBar/SearchBar";
import Cookies from "universal-cookie";
import { useHistory, Link } from "react-router-dom";
import { decode } from "base-64";
import { getNotifications, updateNotification } from "../functions/apis";
import { logout } from "../functions/general";

import {
  HomeIcon,
  UsersIcon,
  BellIcon,
  CogIcon,
} from "@heroicons/react/outline";
// Image
import logo from "../assets/images/logo-w-1.svg";
import logom from "../assets/images/logom.png";
import NotificationBox from "../Components/NotificationBox/NotificationBox";
import ProfilePopup from "./ProfilePopup";
import { connect } from "react-redux";
import {
  setUser,
  notificationData,
  notificationUpdate,
} from "../services/actions/actions";
import { LOGO_PATH, MAIN_URL, PROJECT_NAME } from "../config";
const cookies = new Cookies();
function Navbar({
  rootData,
  setUsers,
  notificationDatas,
  notificationUpdates,
  responsive,
}) {
  if (cookies.get("wmusers")) {
    var user = decode(cookies.get("wmusers"));
  } else {
    var user = "members";
  }
  var token = cookies.get("wmtoken");
  const [isNotify, setIsNotify] = useState(false);
  const [isProfileDP, setIsProfileDP] = useState(false);
  const history = useHistory();
  const handleLogout = () => {
    logout();
    history.replace("/");
  };
  const getWhoIsUser = () => {
    var token = cookies.get("wmtoken");
    var fd = new FormData();
    {
      token && fd.append("token", decode(token));
    }
    fd.append("identity", "wmhandler");
    axios({
      method: "POST",
      url: `${API_ENDPOINT.apiURL}Authentication/fetchUserData`,
      data: fd,
    })
      .then(function (response) {
        setUsers(response.data[0]);
      })
      .catch(function (err) {
        console.log(err);
      });
  };
  useEffect(() => {
    {
      token && getWhoIsUser();
    }
  }, []);
  useEffect(() => {
    if (token) {
      getNotifications().then(function (res) {
        // notificationDatas(res);
      });
      setInterval(() => {
        getNotifications().then(function (res) {
          // notificationDatas(res);
        });
      }, 50000);
    }
  }, []);
  const handleNotification = () => {
    setIsNotify(!isNotify);
    notificationUpdates();
    if (rootData.notificationId > 0) {
      updateNotification(rootData.notificationId);
    }
  };

  return (
    <React.Fragment>
      <div className={`search fixed z-3`} id="navSearch"></div>
      <div className="grid grid-cols-5 gap-x-3 px-10 header py-1 md:py-0">
        <div className="col-span-2 md:col-span-1">
          <div className="brandLogoContainer mr-8 hidden lg:block">
            <Link to={user === "members" ? "/user" : "/i/institute"}>
              <img
                src={LOGO_PATH}
                alt={`${PROJECT_NAME} logo`}
                className=" w-16 h-full"
              />
            </Link>
          </div>
          <div className="brandLogoContainer block md:hidden">
            <Link to={user === "members" ? "/user" : "/i/institute"}>
              <img
                src={LOGO_PATH}
                alt={`${PROJECT_NAME} logo`}
                className="w-12 h-12"
              />
            </Link>
          </div>
        </div>
        <div className="col-span-3 justify-center hidden md:flex">
          {/* <div className="header_search  mr-8 relative w-3/6 rounded-md">
            <SearchBar />
          </div> */}
        </div>
        <div className="col-span-3 md:col-span-1">
          <div className="header_action_icons  d-flex">
            <div className="relative hidden md:block">
              <a
                href={MAIN_URL + "feed"}
                className="flex items-center px-3 py-2 text-white hover:bg-gray-700 rounded-md transition-colors"
              >
                Feeds
              </a>
              {/* <IconButton
                className="bell_ico"
                onClick={() => handleNotification()}
              >
                <BellIcon className=" w-6 text-white relative" />
                {rootData.haveNotification === true && (
                  <div className="redAlert w-2 h-2 bg-red-700 rounded-full absolute top-4 right-5"></div>
                )}
              </IconButton> */}
              {/* <NotificationBox
                className={`${isNotify ? "" : "d-none"}`}
                close={() => setIsNotify(false)}
              /> */}
            </div>
            {rootData.user.avatar ? (
              <div className="profile_wrap ml-3 cursor-pointer relative border bg-white rounded-full">
                <img
                  src={rootData.user.avatar}
                  alt="profile"
                  className="header-profile w-7 h-7"
                  onClick={() => setIsProfileDP(!isProfileDP)}
                  onMouseEnter={() => setIsProfileDP(true)}
                />
                <ProfilePopup
                  className={`${isProfileDP ? "" : "d-none"} hidden md:block`}
                  close={() => setIsProfileDP(false)}
                  logout={() => handleLogout()}
                />
              </div>
            ) : (
              <div className="profile_wrap ml-3 cursor-pointer relative">
                <>
                  <AccountCircleIcon className="landing_avatar" />
                </>
              </div>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return state;
};
const mapDispatchToState = (dispatch) => {
  return {
    setUsers: (value) => {
      dispatch(setUser(value));
    },
    // notificationDatas: (value) => {
    //   dispatch(notificationData(value));
    // },
    notificationUpdates: (value) => {
      dispatch(notificationUpdate(value));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToState)(Navbar);
